export * from './markt-bericht.page';
export * from './markt-bericht.page.resolver';
